import { Prospect } from '../../../../models/Outreach/types'

/** True when any contact field is revealed for this workspace (product "prospect"). */
export function prospectHasRevealedContact(prospect: Prospect): boolean {
    return Boolean(
        prospect.email?.value ||
            prospect.phone?.value ||
            prospect.linkedinProfile?.value,
    )
}
